// Flags de la web.
// COMUNIDAD_HABILITADA: mientras esté en false, la sección Comunidad queda
// oculta (no aparece en el menú, la ruta /comunidad redirige y no hay atajos).
// Ponerla en true recién cuando esté lista para publicar (con moderación).
export const COMUNIDAD_HABILITADA = false;
